if (!customElements.get("product-siblings")) {
  customElements.define(
    "product-siblings",
    class ProductSiblings extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.bindEvents();
      }

      bindEvents() {
        const options = this.querySelectorAll('.f-product-siblings__option');

        options.forEach(option => {
          option.addEventListener('click', (e) => {
            // Add a small delay to show the click state
            option.style.transform = 'scale(0.98)';
            setTimeout(() => {
              option.style.transform = '';
            }, 150);
          });

          // Add keyboard navigation
          option.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              option.click();
            }
          });
        });
      }

      // Method to highlight the current product
      highlightCurrentProduct(productId) {
        const options = this.querySelectorAll('.f-product-siblings__option');

        options.forEach(option => {
          const siblingId = option.dataset.siblingId;
          if (siblingId === productId.toString()) {
            option.classList.add('f-product-siblings__option--current');
            option.setAttribute('aria-current', 'true');
          } else {
            option.classList.remove('f-product-siblings__option--current');
            option.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}

// Initialize siblings functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const siblingsElements = document.querySelectorAll('[data-product-siblings]');

  siblingsElements.forEach(element => {
    if (!element.closest('product-siblings')) {
      // Wrap the element in the custom element if it's not already wrapped
      const wrapper = document.createElement('product-siblings');
      element.parentNode.insertBefore(wrapper, element);
      wrapper.appendChild(element);
    }
  });
});
